<template>
  <div class="container">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 500 500">
      <path fill-opacity="0" stroke-width="1" stroke="#666"
        d="M469,469,305.63,305.63l-31.76-31.76L250,250,404.86,95.14c-85.53-85.52-224.19-85.52-309.72,0s-85.52,224.19,0,309.72,224.19,85.52,309.72,0a218.42,218.42,0,0,0,64.06-160.93" />
      <path id="heart-path" fill-opacity="0" stroke-width="12" stroke="#ED6A5A"
        d="M469,469,305.63,305.63l-31.76-31.76L250,250,404.86,95.14c-85.53-85.52-224.19-85.52-309.72,0s-85.52,224.19,0,309.72,224.19,85.52,309.72,0a218.42,218.42,0,0,0,64.06-160.93" />
    </svg>
  </div>
</template>

<script>
import ProgressBar from 'progressbar.js'
export default {
  name: 'ProgressQ',
  destroyed: function ()
  {
    clearInterval(this.interval)
  },
  mounted: function ()
  {
    var bar = new ProgressBar.Path('#heart-path', {
      easing: 'linear',
      duration: 1000
    })
    let self = this
    bar.set(0)
    this.interval = setInterval(function ()
    {
      if (!self.curr)
      {
        bar.animate(1.0)
        self.curr = !self.curr
      } else
      {
        bar.animate(0)
        self.curr = !self.curr
      }
    }, 1200)
  },
  data: function ()
  {
    return {
      curr: false,
      interval: null
    }
  }
}
</script>

<style scoped>
.container {
  width: 200px !important;
  height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/ProgressQ.vue